import { useEffect, useState } from 'react'

export const useCountdownTimer = (
  initialSeconds: number,
  isActive: boolean
) => {
  const [timeLeft, setTimeLeft] = useState(initialSeconds)

  useEffect(() => {
    if (!isActive || initialSeconds <= 0) {
      setTimeLeft(initialSeconds)
      return
    }

    setTimeLeft(initialSeconds)

    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timer)
          return 0
        }
        return prev - 1
      })
    }, 1000)

    return () => clearInterval(timer)
  }, [isActive, initialSeconds])

  return timeLeft
}
